import _config from '@exp/exp-utils/helper/config';

_config.merge({
  'tccl.perfOn': true,
  'tccl.buildVersion': '2.0.0',
  'tccl.buildEnv': 'prod'
});

export default _config;
